import { Layout } from 'antd';
import React from 'react';
import { Link } from 'react-router-dom';
import { useCurrentUser } from '../context/hooks';
import css from './PageHeader.module.css';
import { UserType } from '../types/user';

const { Header } = Layout;

const PageHeader = React.memo((props) => {
  const currentUser = useCurrentUser();

  const getHeaderTitle = () => {
    switch (currentUser?.type) {
      case UserType.SystemAdmin:
        return 'Administration';
      case UserType.User:
        return 'Account management';
      default:
        return '';
    }
  };

  return (
    <Header className={css.header}>
      <div className={css.headerLeft}>
        <Link style={{ display: 'flex', alignItems: 'center', textDecoration: 'none' }} to="/">
          <img style={{ height: 30 }} src={require('../images/logo_white.svg').default} />
          <span
            style={{
              marginLeft: 10,
              marginTop: 16,
              fontSize: '12px',
              fontFamily: '"Helvetica Neue", Helvetica, Arial, sans-serif',
              fontWeight: 700,
              color: 'white',
              letterSpacing: 1,
              textTransform: 'uppercase',
            }}
          >
            {getHeaderTitle()}
          </span>
        </Link>
      </div>
    </Header>
  );
});

export default PageHeader;
